import client from '@efex-services/axios';
import {
  UpdateTransactionalProfileService,
  UpdateTransactionalProfileServiceResponse,
  UpdateTransactionalProfileServiceData,
} from '../types/updateTransactionalProfileApi';

const createValues = ({
  enterpriseId,
  data,
}: UpdateTransactionalProfileService): Promise<UpdateTransactionalProfileServiceResponse> =>
  client.post(`/enterprise/${enterpriseId}/transactional-profile/`, data);

const updateValues = ({
  enterpriseId,
  data,
}: UpdateTransactionalProfileService): Promise<UpdateTransactionalProfileServiceResponse> =>
  client.put(`/enterprise/${enterpriseId}/transactional-profile/`, data);

const getValues = (
  enterpriseId: string
): Promise<UpdateTransactionalProfileServiceData> =>
  client.get(`/enterprise/${enterpriseId}/transactional-profile/`);

const updateTransactionalProfile = {
  createValues,
  updateValues,
  getValues,
};

export default updateTransactionalProfile;
